import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@seeqdev/qomponents';

interface LockModelConfirmationProps {
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

/**
 * Confirmation dialog shown before locking a model. Locking is permanent
 * and makes the model read-only. The user must check an acknowledgment
 * checkbox before the Lock button is enabled.
 */
export const LockModelConfirmation = ({ onConfirm, onClose }: LockModelConfirmationProps) => {
  const { t } = useTranslation();
  const [understood, setUnderstood] = useState(false);
  const [processing, setProcessing] = useState(false);

  const handleConfirm = async () => {
    setProcessing(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Modal
      open={true}
      title={t('MODELS.LOCK_CONFIRMATION_TITLE')}
      onClose={onClose}
      onSubmit={handleConfirm}
      submitButtonLabel={t('MODELS.LOCK_MODEL')}
      cancelButtonLabel={t('CANCEL')}
      disableSubmitButton={!understood || processing}
      size="md">
      <div data-testid="lockModelConfirmation">
        <p className="tw:mb-4">{t('MODELS.LOCK_CONFIRMATION_MESSAGE')}</p>
        <label className="tw:flex tw:items-start tw:gap-2 tw:cursor-pointer">
          <input
            type="checkbox"
            checked={understood}
            onChange={(e) => setUnderstood(e.target.checked)}
            className="tw:mt-1"
            data-testid="lockConfirmCheckbox"
          />
          <span>{t('MODELS.LOCK_CONFIRMATION_CHECKBOX')}</span>
        </label>
      </div>
    </Modal>
  );
};
